import { InputWidget } from './widget.input';

export class ReadOnlyWidget extends InputWidget {
	type: string = 'readonly';
	inputType!: string;

	constructor(options: {
		value?: string | null;
		name?: string;
		label?: string;
		required?: boolean;
	} = {}) {
		super({...options, ...{inputType: 'text'}});
	}

	getValue(): string | null {
		return this.value;
	}
}
